import "./dashboard.css";

export default function Dashboard() {
  return (
    <div className="dashboard">
      <h2>Bienvenue dans l’interface administrateur</h2>

      <div className="stats">
        

        <div className="stat-card">
          <h3>🚀 Services</h3>
          <p>Pages actives</p>
        </div>
      </div>
    </div>
  );
}
